import * as React from "react";
import { Country } from "../../earth/model/country";
import { Brand } from "../model/brand";
import { KeyedMetrics, MetricKey } from "../model/keyedMetrics";
import { MetricsByBrand } from "../model/metricsByBrand";
import { MetricType } from "../model/metricType";
import { MetricsService } from "../services/metricsService";
import { MetricsChartBar, MetricsChartBarState } from "./metricsChartBar";

interface MetricsChartProps {
    selectedMetricType: MetricType;
    selectedBrands: Brand[];
    selectedCountry: Country | null;
}

export class MetricsChart extends React.Component<MetricsChartProps, {}> {
    private _prevMetrics = new KeyedMetrics();

    render(): JSX.Element {
        let metricType = this.props.selectedMetricType;
        let brands = this.props.selectedBrands;
        let country = this.props.selectedCountry;

        let metrics = this._prevMetrics;
        if (country) {
            metrics = MetricsService.instance.getMetricsForLand(metricType, country);
            metrics = metrics.filterWithKeys(brands).flatten();
            this._prevMetrics = metrics;
        }

        let state: MetricsChartBarState;
        if (country) {
            state = MetricsChartBarState.Visible;
        } else if (metricType.hasSubMetrics) {
            state = MetricsChartBarState.Legend;
        } else {
            state = MetricsChartBarState.Hidden;
        }

        let metricKeys = metricType.hasSubMetrics ? metricType.subMetricKeys : brands;
        return this.renderBars(metricKeys, metrics, state, metricType.linkURL);
    }

    private renderBars(metricKeys: MetricKey[], metrics: KeyedMetrics, state: MetricsChartBarState, linkURL: string): JSX.Element {
        let total = metrics.total;

        let bars = metricKeys.map(it => {
            let value = metrics.getValueForKey(it);
            return <MetricsChartBar key={it.name} metricKey={it} value={value} total={total} state={state} onClick={ () => this.onClick(linkURL)}/>;
        });

        return <div className="hbox bottom-aligned">
            { bars }
        </div>;
    }

    private onClick(link: string) {
        let win = window.open(link, "_blank");
        win!.focus();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/metricsChart.tsx